import rootReducer from './rootReducer';
import { createStore, applyMiddleware, compose } from 'redux';
import multi from 'redux-multi';
import ReduxThunk from 'redux-thunk';
import createStorageMiddleware, { getStorageState } from 'redux-simple-storage-middleware';

const sessionStorageMiddleware = createStorageMiddleware({
  key: 'fcd-redux-session',
  type: 'sessionStorage',
  exclude: ['cache'],
});

const storageState = getStorageState({ key: 'fcd-redux-session' });
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

let store = createStore(
  rootReducer,
  storageState,
  composeEnhancers(applyMiddleware(multi, ReduxThunk, sessionStorageMiddleware)),
);

export default store;

window.reduxStore = store;
